import React, { useState } from "react";
import Page1 from "./Page1";
import MarketplacePage from "./MarketplacePage";
import NftReward from "./NftReward";
import NftBurn from "./NftBurn";
import TradeXToken from "./TradeXToken";
import "bootstrap/dist/css/bootstrap.min.css";

export default function MainApp() {
  const [currentPage, setCurrentPage] = useState("matrix");

  const pages = [
    { 
      key: "matrix", 
      label: "Matrix Dashboard", 
      icon: "🤖", 
      color: "#00ccff",
      component: <Page1 />
    },
    { 
      key: "marketplace", 
      label: "NFT Marketplace", 
      icon: "🎨", 
      color: "#ff00aa",
      component: <MarketplacePage />
    },
    { 
      key: "reward", 
      label: "NFT Reward", 
      icon: "🏆", 
      color: "#00ff88",
      component: <NftReward />
    },
    { 
      key: "burn", 
      label: "NFT Burn", 
      icon: "🔥", 
      color: "#ff5500",
      component: <NftBurn />
    },
    { 
      key: "token", 
      label: "TradeX Token", 
      icon: "🤑", 
      color: "#ffcc00",
      component: <TradeXToken />
    }
  ];

  return (
    <div className="min-vh-100 position-relative overflow-hidden" style={{ 
      background: 'linear-gradient(135deg, #0a0a1a 0%, #1a0a2e 50%, #16213e 100%)',
      fontFamily: "'Inter', 'Segoe UI', sans-serif"
    }}>
      {/* Animated Background */}
      <div className="position-fixed w-100 h-100" style={{
        background: `
          radial-gradient(circle at 25% 25%, rgba(0, 204, 255, 0.15) 0%, transparent 50%),
          radial-gradient(circle at 75% 75%, rgba(255, 0, 170, 0.1) 0%, transparent 50%),
          radial-gradient(circle at 50% 50%, rgba(0, 255, 136, 0.08) 0%, transparent 50%)
        `,
        zIndex: 0,
        top: 0,
        left: 0
      }}></div>

      {/* Top Navigation Bar - Enhanced Responsive */}
      <nav className="navbar navbar-expand-lg fixed-top shadow" style={{
        background: 'rgba(0, 0, 0, 0.9)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        zIndex: 1050,
        padding: '0.5rem 0'
      }}>
        <div className="container-fluid px-3 px-md-4">
          <div className="navbar-brand fw-bold d-flex align-items-center" style={{
            background: 'linear-gradient(135deg, #00ccff, #ff00aa, #00ff88)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontSize: 'clamp(1.2rem, 4vw, 1.5rem)'
          }}>
            🚀 <span className="d-none d-sm-inline">TradeX NFT Hub</span>
            <span className="d-inline d-sm-none">Hub</span>
          </div>

          <div className="navbar-nav d-none d-lg-block">
            <div className="nav-item dropdown">
              <button 
                className="btn dropdown-toggle px-3 px-md-4 py-2 fw-bold"
                type="button" 
                data-bs-toggle="dropdown" 
                aria-expanded="false"
                style={{
                  background: 'linear-gradient(135deg, #00ccff, #ff00aa)',
                  border: 'none',
                  color: '#fff',
                  borderRadius: '25px',
                  fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
                  boxShadow: '0 4px 15px rgba(0, 204, 255, 0.3)'
                }}
              >
                <span className="me-2 fs-5">
                  {pages.find(p => p.key === currentPage)?.icon}
                </span>
                <span className="d-none d-md-inline">
                  {pages.find(p => p.key === currentPage)?.label}
                </span>
                <span className="d-inline d-md-none">
                  {pages.find(p => p.key === currentPage)?.label.split(' ')[0]}
                </span>
              </button>
              <ul className="dropdown-menu dropdown-menu-end shadow-lg" style={{
                background: 'rgba(0, 0, 0, 0.95)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '15px',
                minWidth: 'clamp(200px, 30vw, 300px)',
                maxWidth: '90vw',
                padding: '0.5rem'
              }}>
                {pages.map(page => (
                  <li key={page.key}>
                    <button
                      className={`dropdown-item d-flex align-items-center p-3 ${
                        currentPage === page.key ? 'active' : ''
                      }`}
                      onClick={() => setCurrentPage(page.key)}
                      style={{
                        background: currentPage === page.key ? 
                          `linear-gradient(135deg, ${page.color}20, ${page.color}10)` : 
                          'transparent',
                        color: currentPage === page.key ? page.color : '#fff',
                        borderRadius: '10px',
                        margin: '2px',
                        transition: 'all 0.3s ease',
                        boxShadow: currentPage === page.key ? 
                          `0 4px 15px ${page.color}20` : 'none'
                      }}
                    >
                      <span className="fs-4 me-3">{page.icon}</span>
                      <div className="flex-grow-1">
                        <div className="fw-bold" style={{ fontSize: 'clamp(0.9rem, 2.5vw, 1rem)' }}>
                          {page.label}
                        </div>
                        <small className="text-muted d-none d-md-block" style={{ fontSize: 'clamp(0.7rem, 2vw, 0.8rem)' }}>
                          {page.key === 'matrix' ? 'Matrix operations & stats' : 
                           page.key === 'marketplace' ? 'NFT trading & management' : 
                           'Reward management & claims'}
                        </small>
                      </div>
                      {currentPage === page.key && (
                        <span className="ms-auto">
                          <span className="badge rounded-pill" style={{
                            background: page.color,
                            color: '#000',
                            boxShadow: `0 2px 8px ${page.color}40`
                          }}>
                            ✓
                          </span>
                        </span>
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </nav>

      {/* Page Content - Full Screen */}
      <div style={{ 
        paddingTop: 'clamp(60px, 10vh, 80px)', // Dynamic padding based on screen size
        minHeight: '100vh'
      }}>
        {pages.find(p => p.key === currentPage)?.component}
      </div>

      {/* Enhanced Mobile Navigation */}
      <div className="d-lg-none position-fixed bottom-0 start-0 end-0 pb-3 px-3" style={{
        zIndex: 1040,
        background: 'linear-gradient(to top, rgba(0, 0, 0, 0.9), transparent)',
        backdropFilter: 'blur(10px)'
      }}>
        <div className="d-flex justify-content-around bg-dark rounded-pill p-2 shadow-lg" style={{
          background: 'rgba(0, 0, 0, 0.95)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          maxWidth: '400px',
          margin: '0 auto'
        }}>
          {pages.map(page => (
            <button
              key={page.key}
              className={`btn btn-sm d-flex flex-column align-items-center py-2 px-3 position-relative ${
                currentPage === page.key ? 'active' : ''
              }`}
              onClick={() => setCurrentPage(page.key)}
              style={{
                background: currentPage === page.key ? 
                  `linear-gradient(135deg, ${page.color}, ${page.color}80)` : 
                  'transparent',
                border: 'none',
                color: currentPage === page.key ? '#000' : '#fff',
                borderRadius: '15px',
                transition: 'all 0.3s ease',
                width: '33%'
              }}
            >
              <span className="fs-4 mb-1">{page.icon}</span>
              <small style={{ 
                fontSize: 'clamp(0.6rem, 2vw, 0.7rem)',
                opacity: currentPage === page.key ? 1 : 0.7
              }}>
                {page.label.split(' ')[0]}
              </small>
              {currentPage === page.key && (
                <span className="position-absolute bottom-0 start-50 translate-middle-x bg-white rounded-pill" style={{
                  width: '40%',
                  height: '3px',
                  background: '#fff'
                }}></span>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}